import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import isMobile from '@insight/toolkit-utils/lib/media/isMobile';
import ReactHtmlParser from 'react-html-parser';

import Accordion from '../Accordion/Accordion';
import Carousel from '../Carousel/Carousel';
import { Tab, Tabs, TabManager } from '../Tabs';

export default class DynamicTabs extends Component {
  constructor(props) {
    super(props);

    this.dynamicTabs = React.createRef();
    this.isMobileAccordion = this.mobileLayout == 'accordionTabs';
    this.state = {
      page: 0,
      isMobile: isMobile(),
    };
    this.autoRotate = props.autoRotate;
    this.autoRotateInterval = props.autoRotateInterval;
    this.autoRotateTimeoutHandle = 0;
    this.className = props.className;
    this.componentClassName = props.className;
    this.id = props.id;
    this.inidicator = props.indicator;
    this.isCarousel = props.carousel;
    this.layout = props.layout;
    this.mobileLayout = props.mobileLayout;
    this.tabCount = props.tabs.length;
    this.tabs = props.tabs;
    this.tabsAlign = props.tabsAlign;
    this.carouselOverlap = props.carouselOverlap;
    this.vertical = props.vertical;
  }

  /**
   * When the viewport has been resized, the current page may no longer be
   * valid, so force a refresh.
   */
  onResize = () => {
    this.refreshPage();
  };

  /**
   * Setup resize listeners and trigger an initial refresh.
   */
  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.refreshPage();
  }

  /**
   * Clean up event listeners.
   */
  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  refreshPage() {
    this.setState({ isMobile: isMobile() });
    //    this.render();
  }

  /**
   * Render the DynamicTabs controls and the slides.
   */
  render() {
    // Convert the product data to HTML.
    let tabs = this.tabs;

    let compProps = {
      componentClassName: this.componentClassName,
    };
    if (this.autoRotate) compProps.autoRotate = this.autoRotate;
    if (this.autoRotateInterval)
      compProps.autoRotateInterval = this.autoRotateInterval;
    if (this.indicators) compProps.indicators = this.indicators;
    if (this.tabsAlign) compProps.tabsAlign = this.tabsAlign;
    if (this.vertical) compProps.vertical = this.vertical;
    return (
      <div className={'ds-v1'}>
        <div className={cn('c-dynamic-tabs', this.className)}>
          {this.state.isMobile ? (
            this.isMobileAccordion ? (
              <Accordion
                items={tabs.map((tab, index) => {
                  return {
                    content: tab.content,
                    id: tab.id,
                    label: ReactHtmlParser(tab.name),
                  };
                })}
              />
            ) : (
              <Carousel
                id={`${this.id}-carousel`}
                className={this.componentClassName}
                carouselOverlap={this.carouselOverlap}
                {...compProps}
              >
                {tabs.map((tab, index) => {
                  return tab.content;
                })}
              </Carousel>
            )
          ) : this.isCarousel ? (
            <Carousel
              id={`${this.id}-carousel`}
              className={this.componentClassName}
              carouselOverlap={this.carouselOverlap}
              {...compProps}
            >
              {tabs.map((tab, index) => {
                return tab.content;
              })}
            </Carousel>
          ) : (
            <TabManager
              id={`${this.id}-tabmanager`}
              tabs={tabs}
              {...compProps}
            ></TabManager>
          )}
        </div>
      </div>
    );
  }
}

DynamicTabs.propTypes = {
  autoRotate: PropTypes.bool,
  autoRotateInterval: PropTypes.number,
  carousel: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  componentClassName: PropTypes.string,
  id: PropTypes.string.isRequired,
  inidicator: PropTypes.bool,
  layout: PropTypes.string,
  mobileLayout: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.node.isRequired,
      id: PropTypes.string.isRequired,
      name: PropTypes.node.isRequired,
    })
  ).isRequired,
  tabsAlign: PropTypes.string,
  vertical: PropTypes.bool,
};

DynamicTabs.defaultProps = {
  autoRotate: false,
  autoRotateInterval: 0,
  carousel: false,
  className: '',
  componentClassName: '',
  indicator: false,
  layout: '',
  mobileLayout: '',
  tabs: [],
  tabsAlign: 'center',
  vertical: false,
};
